import { supabase } from './supabase';

export async function getEdgeFunctionHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not authenticated');
  const anonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session.access_token}`,
    ...(anonKey ? { apikey: anonKey } : {}),
    'x-client-info': 'adforge-ai-web',
    'x-request-id': crypto.randomUUID(),
  };
}
